import React from 'react';

const PaymentGatewayFields = ({ formData, onChange, errors = {}, embedded = false }) => {
  if (!formData?.can_access?.payment_gateway) {
    return null;
  }

  const pg = formData.payment_gateway || {};

  const handlePgChange = (e) => {
    const { name, value } = e.target;
    onChange({
      target: {
        name: 'payment_gateway',
        value: {
          ...pg,
          provider: pg.provider || 'razorpay',
          [name]: value,
        },
      },
    });
  };

  return (
    <div>
      {!embedded && (
        <h3 className="text-base sm:text-md font-semibold text-gray-700 mb-3 sm:mb-4 pb-2 border-b-2 border-grey-400">
          Payment Gateway (Razorpay)
        </h3>
      )}
      <p className="text-xs sm:text-sm text-gray-500 mb-3">
        Used for UPI / Online QR collection while creating a shipment or recording a shipment payment.
        Configure the webhook URL in Razorpay Dashboard pointing to{' '}
        <code className="text-xs bg-gray-100 px-1 rounded">/api/webhooks/razorpay</code>
        {' '}and enable events <code className="text-xs bg-gray-100 px-1 rounded">payment_link.paid</code>
        {' '}and <code className="text-xs bg-gray-100 px-1 rounded">payment.captured</code>.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-6">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Key ID
          </label>
          <input
            type="text"
            name="key_id"
            value={pg.key_id || ''}
            onChange={handlePgChange}
            placeholder="rzp_live_..."
            className={`w-full px-3 sm:px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base ${
              errors.key_id ? 'border-red-400' : 'border-gray-300'
            }`}
            autoComplete="off"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Key Secret
          </label>
          <input
            type="password"
            name="key_secret"
            value={pg.key_secret || ''}
            onChange={handlePgChange}
            placeholder={pg.has_key_secret ? '•••••••• (leave blank to keep)' : 'Enter key secret'}
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="new-password"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Webhook Secret
          </label>
          <input
            type="password"
            name="webhook_secret"
            value={pg.webhook_secret || ''}
            onChange={handlePgChange}
            placeholder={pg.has_webhook_secret ? '•••••••• (leave blank to keep)' : 'Enter webhook secret'}
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="new-password"
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentGatewayFields;
